import React from "react";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";
import RestrictionPanel from "@/components/term/RestrictionPanel";

const Restriction = () => {
  const history = useHistory()

  return (
    <div className="App" style={{padding: '40px'}}>
      <RestrictionPanel/>
      <MButton image={'back.png'} onClick={() => history.goBack()} value={'戻る'} />
    </div>
  )
}

export default Restriction;
